// Webpack Imports
import * as bootstrap from 'bootstrap';

/**
 *
 * @param {string} zoneId
 * @return {NodeListOf<HTMLElement>}
 */
function findZoneLauncher(zoneId) {
    return document.querySelectorAll(`[aria-controls="${zoneId}"]`);
}

/**
 *
 * @param {HTMLElement} zone
 * @param {string} targetId
 */
function closeReactiveZone(zone, targetId) {
    zone.classList.remove('is-open');


    if (targetId) {
        document.body.classList.remove(`has-open-zone--${targetId}`);

        findZoneLauncher(targetId).forEach(launcher => {
            launcher.setAttribute('aria-expanded', 'false');
            launcher.classList.remove('is-active');
        });
    }

}

/**
 *
 * @param {HTMLElement} zone
 * @param {string} targetId
 */
function openReactiveZone(zone, targetId) {
    zone.classList.add('is-open');

    if (targetId) {
        document.body.classList.add(`has-open-zone--${targetId}`);

        findZoneLauncher(targetId).forEach(launcher => {
            launcher.setAttribute('aria-expanded', 'true');
            launcher.classList.add('is-active');
        });
    }
}

function initZoneLaunchers() {

    /**
     * Open and close branding side menu on small screen
     * @param {HTMLElement} button
     * @param {HTMLElement} target
     * @param {string} id
     */
    const toggleZone = (button, target, id) => {

        if (!button || !target) {
            return;
        }

        const expanded = button.getAttribute('aria-expanded');
        const isOpen = expanded === 'true';

        if (isOpen) {
            closeReactiveZone(target, id);
        } else {
            openReactiveZone(target, id);
        }
    }


    // Toggle menu on mobile
    document.querySelectorAll('.zone-opener').forEach(button => {


        const targetId = button.getAttribute('aria-controls');

        if (!targetId) {
            return;
        }

        const target = document.getElementById(targetId);

        if (!target) {
            button.style.display = 'none';
            return;
        }

        button.addEventListener('click', () => toggleZone(button, target, targetId));
    });
}


/**
 *
 * Get branding header
 * @return {HTMLElement|null}
 */
function getHeader() {
    return document.querySelector('.branding-header');
}

function computeHeaderHeight() {
    const height = getHeader()?.getBoundingClientRect().height;
    document.body.style.setProperty('--wp--custom--header--height', (height ?? 0) + "px");
}


(function () {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    
    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });

    initZoneLaunchers();

    if (getHeader()) {
        computeHeaderHeight();
        window.addEventListener('resize', computeHeaderHeight);
    }

})();